import { TopChartsData } from '@features/campaigns/performance/components/TopCharts/TopCharts.types.ts';
import { apiRoutes } from '@features/campaigns/performance/consts/apiRoutes';
import { apiClient } from '@shared/api/ApiClient';
import { CampaignId } from '@shared/types/campaign';

export async function getCampaignTopCharts(campaignId: CampaignId): Promise<TopChartsData | null> {
  return await apiClient.get<TopChartsData>(apiRoutes.getCampaignTopCharts(campaignId));
}
